export const live = {
    zbz: "直播中",
    ljks: "立即开始",
    hmyzb: "您还没有直播过哦~",
    zbyg: "直播预告",
    yjs: "已结束",
    jszb: "结束直播",
    gbzb: "关闭直播",
    jxzb: "继续直播",
    bctp: "保存图片",
    fxlj: "分享链接",
    zbydk: "直播已断开，请稍后...",
    fh: "返 回",
    wjcdypsb: "未检测到音频设备",
    czsb: "Canvas操作失败:",
    tpjzsb: "图片加载失败，请检查URL是否正确且图片可访问",
    zbjl: "直播记录",
    sqjl: "申请记录",
    lts: "聊天室",
    ren: "人",
    gdcy: "更多成员",
    cy: "成员",
    jcjy: "解除禁言",
    jy: "禁言",
    qbjy: "全部禁言",
    zbjs: "直播介绍",
    srnr: "请输入内容",
    tczbj: "您已被踢出直播间",
    qd: "确   定",
    zbjjjs: "您的直播10min后将自动结束！",
    zbsc: "直播时长：",
    ljgkrs: "累计观看人数：",
    dzs: "点赞数：",
    zbjies: "直播结束",
    ybjy: "您已被禁言",
    jycg: "解言成功",
    jinycg: "禁言成功",
    qbjinycg: "全部禁言成功",
    qbjycg: "全部解言成功",
    cwzb: "成为主播",
    lxgzry: "请联系工作人员成为主播",
    lxfs: "联系方式",
    zb: "直播",
    xkt: "Biking小课堂",
    sqzb: "申请直播",
    bczbzt: "本场直播主题",
    srzt: "请输入主题",
    bczbjj: "本场直播简介",
    kbsj: "开播时间",
    xzrisj: "选择日期时间",
    tishi: "提示",
    dksdzb: "该时间点有 1 场待开始的直播",
    cxsj: "持续时间",
    xzsc: "选择时长",
    fmt: "封面图",
    fmtbnwk: "封面图不能为空",
    sc: "上传",
    yssc: "最大10MB，请压缩后上传",
    sccct: "请上传360*170 尺寸的图",
    tjsq: "提交申请",
    tpcj: "图片裁剪",
    tzcjwz: "调整裁剪框位置，选择要保留的区域",
    scdtp: "上传的图片",
    yl: "预览 (360×170)",
    cjtp: "裁剪图片",
    quxiao: "取消",
    qsrzbjj: "请输入本场直播简介",
    qxzrq: "请选择日期",
    qxzsc: "请选择时长",
    kssjdydqsj: "开始时间必须大于当前时间",
    sctxtpdx: "上传头像图片大小不能超过 10MB!",
    tjcg: "提交成功",
    jkshnr: "我们将尽快审核您的申请内容",
    hmysqgzb: "您还没有申请直播过哦~",
    shz: "审核中",
    tongg: "通过",
    jujue: "拒绝",
    yugao: "预告",
    huifang: "回放",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/zh.js